import { useI18n } from 'builder/hooks/useI18n'
import LOCATION from '../assets/location.png'
import * as Styles from './styles'

const TRANSLATION = 'builder.job_search.recommendations.missing_profile_information'

type Props = {
  onClick: () => void
}

export const NoLocation = ({ onClick }: Props) => {
  const { i18n } = useI18n()

  return (
    <Styles.Container data-testid="no-location-card">
      <Styles.ImageWrapper>
        <Styles.LocationPin src={LOCATION} />
      </Styles.ImageWrapper>
      <Styles.DetailsWrapper>
        <Styles.InfoContainer>
          <Styles.Title>{i18n.t(`${TRANSLATION}.no_location.title`)}</Styles.Title>
          <Styles.SubTitle>{i18n.t(`${TRANSLATION}.no_location.subtitle`)}</Styles.SubTitle>
        </Styles.InfoContainer>
        <Styles.ButtonWrapper>
          <Styles.Button data-testid="no-location-card-button" onClick={onClick}>
            {i18n.t(`${TRANSLATION}.no_location.button`)}
          </Styles.Button>
          <Styles.Icon />
        </Styles.ButtonWrapper>
      </Styles.DetailsWrapper>
    </Styles.Container>
  )
}
